import React, { SVGProps } from 'react';

const SortAsc: React.FC<SVGProps<SVGSVGElement>> = props => (
    <svg style={{ marginLeft: '5px', width: '15px',height:'15px', opacity:'0.8' }} version="1.1" id="Layer_1" x="0px" y="0px"
        viewBox="0 0 512 512">
        <g>
            <path d="M26.9,121.3h188.6c14.9,0,26.9-12.1,26.9-26.9c0-14.9-12.1-26.9-26.9-26.9H26.9C12.1,67.4,0,79.4,0,94.3
       C0,109.2,12.1,121.3,26.9,121.3"/>
            <path d="M26.9,282.9h188.6c14.9,0,26.9-12.1,26.9-26.9c0-14.9-12.1-26.9-26.9-26.9H26.9C12.1,229.1,0,241.1,0,256
       C0,270.9,12.1,282.9,26.9,282.9"/>
            <path d="M26.9,444.6h242.5c14.9,0,26.9-12.1,26.9-26.9c0-14.9-12.1-26.9-26.9-26.9H26.9C12.1,390.7,0,402.8,0,417.7
       C0,432.6,12.1,444.6,26.9,444.6"/>
            <path d="M342.4,194.2l61.8-61.8l61.8,61.8c10.5,10.5,27.6,10.5,38.1,0s10.5-27.6,0-38.1l-80.8-80.8c-10.5-10.5-27.6-10.5-38.1,0
       l-80.8,80.8c-10.5,10.5-10.5,27.6,0,38.1C314.8,204.7,331.9,204.7,342.4,194.2L342.4,194.2z"/>
            <path d="M377.3,94.3v323.4c0,14.9,12.1,26.9,26.9,26.9c14.9,0,26.9-12.1,26.9-26.9V94.3c0-14.9-12.1-26.9-26.9-26.9
       C389.3,67.4,377.3,79.4,377.3,94.3"/>
        </g>
    </svg>
);

export default SortAsc;
